import type { AccessConstraint } from '@sb/shared/access';
import { PlanType } from '@shiftbase-com/ts-shared/models';

/** Access constraints for the top-level authenticated feature routes whose gate is declared on the parent route here (the lazy children live in their own modules). */
export const authenticatedAccess = {
  hiring: { subscriptionPlan: PlanType.BASIC },
  timesheet: { permission: ['View all timesheets', 'View own timesheet'] },
  reports: { permission: ['View reports'] },
} satisfies Record<string, AccessConstraint>;
